import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UiMessage } from '../../types/ui-message.type';

@Component({
    selector: 'app-chat-message',
    templateUrl: './chat-message.component.html',
    styles: [
        `
            :host {
                @apply flex flex-col gap-2;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ChatMessageComponent {
    @Input() public message: UiMessage;
}
